// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let RentalNeedAreas = require("../RentalNeedAreas.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RentalNeed__Status = require("../../qa/AllInRentalNeed/RentalNeed__Status.bs.js");
let RentalNeedPriceRange = require("../RentalNeedPriceRange.bs.js");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let VisuallyHidden = require("@reach/visually-hidden").default;
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalNeedLeaseAttributes = require("../RentalNeedLeaseAttributes.bs.js");
let RentalNeedPropertyAttributes = require("../RentalNeedPropertyAttributes.bs.js");
let ClientNeedSearchResultTimestamp = require("./ClientNeedSearchResultTimestamp.bs.js");
let RentalNeedSearchResult_rentalNeed_graphql = require("../../../__generated__/RentalNeedSearchResult_rentalNeed_graphql.bs.js");
let RentalNeedSearchResultTimestamp_rentalNeed_graphql = require("../../../__generated__/RentalNeedSearchResultTimestamp_rentalNeed_graphql.bs.js");

let convertFragment = RentalNeedSearchResult_rentalNeed_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedSearchResult_rentalNeed_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedSearchResult_rentalNeed_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalNeedSearchResult_rentalNeed_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedSearchResult_rentalNeed_graphql.node, convertFragment, fRef);
}

let RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = RentalNeedSearchResultTimestamp_rentalNeed_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalNeedSearchResultTimestamp_rentalNeed_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalNeedSearchResultTimestamp_rentalNeed_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RentalNeedSearchResultTimestamp_rentalNeed_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(RentalNeedSearchResultTimestamp_rentalNeed_graphql.node, convertFragment$1, fRef);
}

let RentalNeedFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function RentalNeedSearchResult$Timestamp$WithoutErrorBoundary(props) {
  let rentalNeed = RescriptRelay_Fragment.useFragment(RentalNeedSearchResultTimestamp_rentalNeed_graphql.node, convertFragment$1, props.rentalNeed);
  let v = Stdlib_Option.map(Stdlib_Array.keepSome(rentalNeed.broadcasts.edges)[0], e => e.node.broadcastAt);
  let broadcastAt = v !== undefined ? Primitive_option.valFromOption(v) : Stdlib.panic("Missing `broadcastAt`.");
  return JsxRuntime.jsx(ClientNeedSearchResultTimestamp.make, {
    updatedAt: rentalNeed.updatedAt,
    broadcastAt: broadcastAt
  });
}

let WithoutErrorBoundary = {
  make: RentalNeedSearchResult$Timestamp$WithoutErrorBoundary
};

function RentalNeedSearchResult$Timestamp(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "rental need search result timestamp",
    children: JsxRuntime.jsx(RentalNeedSearchResult$Timestamp$WithoutErrorBoundary, {
      rentalNeed: props.rentalNeed
    })
  });
}

let Timestamp = {
  RentalNeedFragment: RentalNeedFragment$1,
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: RentalNeedSearchResult$Timestamp
};

function RentalNeedSearchResult(props) {
  let rentalNeed = RescriptRelay_Fragment.useFragment(RentalNeedSearchResult_rentalNeed_graphql.node, convertFragment, props.rentalNeed);
  let isMobile = MediaQuery.isMobile();
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(RentalNeedPriceRange.make, {
                    rentalNeed: rentalNeed.fragmentRefs,
                    size: "medium"
                  }),
                  className: "flex-1"
                }),
                JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(RentalNeed__Status.make, {
                    rentalNeed: rentalNeed.fragmentRefs
                  })
                })
              ],
              className: "flex flex-row justify-between mb-4"
            }),
            JsxRuntime.jsx("div", {
              children: Stdlib_Option.getOr(rentalNeed.headline, ""),
              className: "text-xl mt-2 line-clamp-2"
            })
          ]
        }),
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RentalNeedAreas.make, {
                rentalNeed: rentalNeed.fragmentRefs
              }),
              className: "mt-6"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RentalNeedPropertyAttributes.make, {
                rentalNeed: rentalNeed.fragmentRefs
              }),
              className: "mt-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RentalNeedLeaseAttributes.make, {
                rentalNeed: rentalNeed.fragmentRefs
              }),
              className: "mt-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(AgentInfo.make, {
                agent: rentalNeed.agent.fragmentRefs
              }),
              className: "mt-8"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(RentalNeedSearchResult$Timestamp, {
                rentalNeed: rentalNeed.fragmentRefs
              }),
              className: "mt-4"
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                href: "/client_needs/" + rentalNeed.id,
                size: "small",
                className: "flex-1 justify-center",
                children: JsxRuntime.jsxs(ViewStack.make, {
                  space: "xs",
                  flexDirection: "row",
                  children: [
                    JsxRuntime.jsx(IconV5.make, {
                      icon: "view-details"
                    }),
                    JsxRuntime.jsx("div", {
                      children: isMobile ? JsxRuntime.jsx(VisuallyHidden, {
                          children: "View Details"
                        }) : "View Details"
                    })
                  ]
                })
              }),
              className: "mt-4 flex"
            })
          ]
        })
      ],
      className: "flex flex-col justify-between h-full"
    }),
    className: "bg-white rounded-md border p-4 hover:shadow-lg"
  });
}

let make = RentalNeedSearchResult;

exports.RentalNeedFragment = RentalNeedFragment;
exports.Timestamp = Timestamp;
exports.make = make;
/* IconV5 Not a pure module */
